/** The arm's own 404 with three likely destinations; a redirect home would tell a crawler the
 * address is fine. `routes/v2/$.tsx` sets the 404 status and `noindex`; the root not-found
 * (components/app/shell/not-found.tsx) does the same and asks for these head tags. */
export function PeopleNotFound({ withHead = false }: { withHead?: boolean }) {
  return (
    <main className="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center gap-4 px-6 py-24 text-center">
      {withHead ? (
        <>
          <title>Page not found | PEOPLE AI Workforce</title>
          <meta name="robots" content="noindex" />
        </>
      ) : null}
      <p className="text-muted-foreground text-5xl font-semibold tabular-nums">404</p>
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-muted-foreground text-sm">
        There is no page at this address on ppl-ai.com. It may have moved, or the link may be wrong.
      </p>
      <nav aria-label="Where to go instead" className="mt-2 flex flex-wrap justify-center gap-3">
        <a
          href="/"
          className="rounded-md border border-current/30 px-4 py-2 text-sm font-medium hover:bg-current/10"
        >
          Home
        </a>
        <a
          href="/workforce"
          className="rounded-md border border-current/30 px-4 py-2 text-sm font-medium hover:bg-current/10"
        >
          The AI workforce
        </a>
        <a
          href="/demo"
          className="rounded-md border border-current/30 px-4 py-2 text-sm font-medium hover:bg-current/10"
        >
          Book a demo
        </a>
      </nav>
    </main>
  );
}
